import React, { useEffect, useRef } from "react";
import moment from "moment";
import { Divider } from "antd";

import { inputFields, Loader } from "../../components";
import { Images, Utils } from "../../config";

const formatDividerDate = (date) => {
  const givenDate = moment(date);

  if (moment().isSame(givenDate, "day")) {
    return "Today";
  } else if (moment().subtract(1, "day").isSame(givenDate, "day")) {
    return "Yesterday";
  } else {
    return givenDate.format("MMMM Do YYYY");
  }
};

const WithMessages = ({
  messages = [],
  handleSendMessage,
  setMessage,
  message,
  profileData,
  loading = false,
  isAddLoading = false,
}) => {
  const lastMessageRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (isAddLoading && bottomRef.current) {
      bottomRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } else if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [messages.length, isAddLoading]);

  let lastMessageDate = null;

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center gap-4 my-[1em] mt-[6em]">
      <div className="ai-chatbot-chat-messages">
        {loading ? (
          <Loader.Circular />
        ) : (
          <>
            {messages?.map((msg, index) => {
              const messageDate = moment(msg?.updatedAt).startOf("day");
              let showDivider = false;

              if (
                !lastMessageDate ||
                !lastMessageDate.isSame(messageDate, "day")
              ) {
                showDivider = true;
                lastMessageDate = messageDate;
              }

              const isLast = index === messages.length - 2;

              return (
                <div key={index} className="flex flex-col">
                  {showDivider && (
                    <Divider>
                      <div className="text-gray-500 text-[0.75em]">
                        {formatDividerDate(msg?.updatedAt)}
                      </div>
                    </Divider>
                  )}

                  <div
                    ref={isLast && !isAddLoading ? lastMessageRef : null}
                    className={`${
                      msg?.role === "assistant"
                        ? "ai-chatbot-incoming-chat-container"
                        : "ai-chatbot-outgoing-chat-container"
                    }`}
                  >
                    <div>
                      <img
                        src={
                          msg?.role === "assistant"
                            ? Images.VisionAILogo
                            : profileData?.profileImage
                        }
                        className="h-[2.5em] w-[2.5em] rounded-full object-cover"
                      />
                    </div>

                    <div className="ai-chatbot-chat">
                      {String(msg?.content || "")
                        .split("\n")
                        .map((line, i) => (
                          <React.Fragment key={i}>
                            {Utils.renderBold(line)}
                            <br />
                          </React.Fragment>
                        ))}

                      <div className="text-[0.625em] font-medium text-end">
                        {moment(msg?.updatedAt).format("h:mm A")}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {isAddLoading && (
              <div className="flex flex-col">
                <div className="ai-chatbot-incoming-chat-container">
                  <div>
                    <img
                      src={Images.VisionAILogo}
                      className="h-[2.5em] w-[2.5em] rounded-full object-cover"
                    />
                  </div>
                  <div className="ai-chatbot-chat">
                    <div className="flex items-center gap-2 text-gray-500">
                      <span>VisionAI is thinking</span>
                      <Loader.TypingIndicator />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <div ref={bottomRef} />
      </div>

      <div className="w-[70%]">
        <inputFields.VisionAIChatInput
          onChange={(e) => setMessage(e.target.value)}
          onClick={handleSendMessage}
          value={message}
          onKeyDown={handleKeyDown}
          loading={isAddLoading}
          disabled={isAddLoading}
          disablePrompt={false}
        />
      </div>
    </div>
  );
};

export default WithMessages;
